<script>
import registrationBtn from "../ui/registrationBtn.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";

export default {
    name: 'HowWorks',
    components: {
        registrationBtn,
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            slides: [
                {
                    text: 'Проходите регистрацию, в зависимости от категории пользователя (специалист, компания, образовательное учреждение)',
                    image: require('../../assets/image/howSlider_1.png')
                },
                {
                    text: 'Заполняете анкетные данные. Если Вы специалист, то Вы должны прикрепиться к компании и учебному заведению',
                    image: require('../../assets/image/howSlider_2.png')
                },
                {
                    text: 'Если Вы зарегистрировались как компания, Вам необходимо подтвердить всех сотрудников в списке профиля.',
                    image: require('../../assets/image/howSlider_3.png')
                },
                {
                    text: 'Если регистрация в качестве образо- вательного учреждения, Вам нужно просто подтверждать входящие заявки.',
                    image: require('../../assets/image/howSlider_4.png')
                },
                {
                    text: 'Вы также можете зарегистрироваться в качестве HR-агента для поиска специа- листов и представления их интересов.',
                    image: require('../../assets/image/howSlider_5.png')
                },
                {
                    text: 'Организации получают возможность выкупить специалиста. Трансферная стоимость вычисляется формулами.',
                    image: require('../../assets/image/howSlider_6.png')
                },
                {
                    text: 'При покупке специалиста, заработок распределяется по образовательным учреждениям. Повышается мотивация.',
                    image: require('../../assets/image/howSlider_7.png')
                },
                {
                    text: 'По сути компании вносят реальный вклад в будущее Российского обра- зования, получая качество кадров.',
                    image: require('../../assets/image/howSlider_8.png')
                },

            ],
            missions: [
                {
                    text: 'Миссия компании', title: 'Российская компания Sobes Market', text2: 'Стремится к улучшению качества образования, благодаря которому в нашей стране не будет проблем, связанных с нехваткой квалифицированных кадров.<br><br>Благодаря особой технологии, разработанной основателями компании, наша компания сможет вывести рекрутинг на новый уровень, предоставив возможность образовательной индустрии зарабатывать больше средств, для того, чтобы они могли вкладывать их в апгрейд собственной образовательной среды.'
                },
                {
                    text: 'Цели компании', title: 'Улучшение качества развития страны', text2: 'Наша компания горит ярким желанием содействовать развитию страны в целом, поэтому было принято решение, разработать проект, который начнет решать задачу в корне, а именно благодаря помощи в развитии образовательной индрустрии.<br><br>Самое главное, что благодаря нашей разработке, преимущество будет у всех сторон: Образовательные учреждения будут получать дополнительный доход, специалисты смогут получать увеличенный доход, а компании перестанут нуждаться в крутых кадрах!'
                }
            ],
            activeIndex: 0
        };
    },
    methods: {
        onSlideChange(swiper) {
            this.activeIndex = swiper.activeIndex;
        }
    },
    setup() {
        return {
            modules: [Navigation, Pagination, Scrollbar, A11y],
        };
    }
}
</script>


<template>
    <div class="how-works">
        <div class="container">
            <div class="how-works__content">
                <h2 class="how-works__content-title">Как это работает?</h2>
                <div class="how-works__swiper-list">
                    <swiper :space-between="40" :modules="modules" :centered-slides="true"
                        :breakpoints="{
                            300: { slidesPerView: 1, spaceBetween: 20 },
                            650: { slidesPerView: 2, spaceBetween: 20 },
                            991: { slidesPerView: 2.4, spaceBetween: 30 },
                            1440: { slidesPerView: 3.3, spaceBetween: 40 }
                        }" @slideChange="onSlideChange">
                        <swiper-slide v-for="(slide, index) in slides" :key="index"
                            class="how-works__swiper-item">
                            <div class="how-works__text-wrapper">
                                <p class="how-works__swiper-number">0{{ index + 1 }}</p>
                                <p class="how-works__swiper-text">{{ slide.text }}</p>
                            </div>
                            <registrationBtn
                                :style="{ opacity: activeIndex === index ? 1 : 0, transition: 'opacity 0.5s', visibility: activeIndex === index ? 'visible' : 'hidden' }" />
                            <img class="how-works__swiper-image" :src="slide.image" alt="">
                        </swiper-slide>
                    </swiper>
                </div>
            </div>
            <div class="how-works__mission-wrapper">
                <div class="how-works__mission-inner" v-for="(mission, index) in missions" :key="index">
                    <p class="how-works__mission-text_top">{{ mission.text }}</p>
                    <h2 class="how-works__mission-title">{{ mission.title }}</h2>
                    <p class="how-works__mission-text" v-html="mission.text2"></p>
                </div>
            </div>
        </div>
    </div>
</template>



<style scoped>
.how-works__content {
    border-radius: 100px;
    background-color: #1A1A1A;
    padding-bottom: 115px;
    background-image: url('../../assets/image/backgroundHow.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center left 136px;
}

.how-works__mission-wrapper {
    display: flex;
    justify-content: space-between;
    gap: 50px;
    padding-top: 70px;
}

.how-works__mission-inner {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.how-works__mission-text {
    max-width: 766px;
    color: #1A1A1A;
    font-family: Aeroport;
    font-size: 18px;
    font-style: normal;
    font-weight: 300;
    line-height: 150%;
    padding: 10px 0;
}

.how-works__swiper-item {
    border-radius: 35px 35px 231px 231px;
    background: #FFF;
    padding: 15px;
    padding-top: 60px;
    max-width: 462px;
    height: 545px;
    display: flex;
    flex-direction: column;
    gap: 40px;
    align-items: center;
}

.how-works__mission-title {
    color: #1A1A1A;
    font-family: Aeroport;
    font-size: 35px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.how-works__mission-text_top {
    border-radius: 17px;
    background: #1A1A1A;
    color: #FFF;
    font-family: Aeroport;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    max-width: 153px;
    text-align: center;
    padding: 6px 0;
}

.how-works__swiper-text {
    color: #1A1A1A;
    font-family: Aeroport;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    max-width: 401px;
}

.how-works__swiper-number {
    color: #80879C;
    font-family: Aeroport;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.how-works__content-title {
    color: #FFF;
    text-align: center;
    font-family: Aeroport;
    font-size: 60px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -3px;
    padding-top: 84px;
    padding-bottom: 100px;
}
.how-works__swiper-image {
    margin-top: 27px;
}
.how-works__text-wrapper {
    display: flex;
    flex-direction: column;
    gap: 5px;
}
@media (max-width: 991px) {
    .how-works__mission-wrapper {
        flex-direction: column;
        gap: 40px;
        padding-top: 70px;
    }
    .how-works__mission-text {
        max-width: 100%;
    }
}
@media (max-width: 650px) {
   
    .how-works__content-title {
        font-size: 32px;
        line-height: 43px;
        padding-top: 45px;
        padding-bottom: 30px;
    }
    .how-works__swiper-item {
        max-width: 100%;
        height: auto;
        min-height: 438px;
        border-radius: 25px 25px 231px 231px;
        padding: 30px 26px 40px;
        gap: 15px;
    }
    .how-works__text-wrapper {
        gap: 12px;
    }
    .how-works__swiper-text {
        font-size: 16px;
        max-width: 100%;
        line-height: 21px;
        margin-bottom: 25px;
    }
    .how-works__content {
        padding-bottom: 45px;
        border-radius: 50px;
    }
    .how-works__swiper-list {
        padding: 0 30px;
    }
    .how-works__swiper-image {
        margin-top: 0;
        width: 100px;
        height: 100px;
    }
    .how-works__mission-wrapper {
        padding-top: 40px;
    }
    .how-works__mission-title {
        font-size: 28px;
    }
    .how-works__mission-text{
        font-size: 16px;
    }
}
</style>